export const trendTabbarMapping = [
  {
    typeName: '綜合',
    list: [
      {
        label: '开奖号码',
        value: 'KaiJiangHaoMa'
      },
      {
        label: '热门号码统计',
        value: 'ReMenHaoMaTongJi'
      },
      {
        label: '遗漏号码统计',
        value: 'YiLouHaoMaTongJi'
      },
      {
        label: '热门生肖统计',
        value: 'ReMenShengXiaoTongJi'
      },
      {
        label: '遗漏生肖统计',
        value: 'YiLouShengXiaoTongJi'
      }
    ]
  },
  {
    typeName: '路珠',
    list: [
      {
        label: '单双路珠',
        value: 'DanShuangLuJhu'
      },
      {
        label: '大小路珠',
        value: 'DaXiaoLuJhu'
      },
      {
        label: '波色路珠',
        value: 'BoSeLuJhu'
      },
      {
        label: '总和单双路珠',
        value: 'ZongHeDanShuangLuZhu'
      },
      {
        label: '总和大小路珠',
        value: 'ZongHeDaXiaoLuZhu'
      },
      {
        label: '尾数大小路珠',
        value: 'WeiShuDaXiaoLuZhu'
      },
      {
        label: '合数单双路珠',
        value: 'HeShuDanShuangLuZhu'
      }
    ]
  },
  {
    typeName: '走势',
    list: [
      {
        label: '正码走势',
        value: 'ZhengMaZouShi'
      },
      {
        label: '特码走势',
        value: 'TeMaZouShi'
      },
      {
        label: '生肖走势',
        value: 'ShengXiaoZouShi'
      },
      {
        label: '家禽野兽走势',
        value: 'JiaQinYeShouZouShi'
      },
      {
        label: '男女生肖走势',
        value: 'NanNuShengXiaoZouShi'
      },
      {
        label: '天地生肖走势',
        value: 'TianDiShengXiaoZouShi'
      },

      {
        label: '四季生肖走势',
        value: 'SiJiShengXiaoZouShi'
      },
      {
        label: '琴棋书画走势',
        value: 'QinQiShuHuaZouShi'
      },
      {
        label: '三色生肖走势',
        value: 'SanSeShengXiaoZouShi'
      }
    ]
  }
]
